import { Grid } from '@material-ui/core'
import { FormControl, InputLabel, MenuItem, Select } from '@mui/material'
import axios from 'axios';
import React, { useEffect, useState } from 'react'
import { getDecryptDataFromLocal } from '../../../utils/encrypt';

export default function DashboardManager(props) {
    const { agentType, handleViewManagerWise, compact = false } = props;
    const [floorManagerList, setFloorManagerList] = useState([])
    const [teamLeadList, setTeamLeadList] = useState([])
    const [floorManagerID, setFloorManagerID] = useState('')
    const [teamLeadID, setTeamLeadID] = useState('')
    const [managerID, setManagerID] = useState('')
    const [managerList, setManagerList] = useState([])

    const role = getDecryptDataFromLocal('setRole')

    const getManagerList = () => {
        axios({
            method: 'POST',
            url: `${process.env.REACT_APP_PATH}/role2/managerSearch`,
            data: { refferdByAgenttype: agentType }
        }).then(res => {
            setManagerList(res.data.data);
        }).catch(() => {})
    }

    const getFloorManagerList = (mId = managerID) => {
        axios({
            method: 'GET',
            url: `${process.env.REACT_APP_PATH}/role2/floorManagerSearch?mId=${mId}`,
        }).then(res => {
            setFloorManagerList(res.data.data);
        }).catch(() => {})
    }

    const getTeamLeadList = (fmId = floorManagerID) => {
        axios({
            method: 'GET',
            url: `${process.env.REACT_APP_PATH}/role2/TeamLeadSearch?immediateSeniorId=${fmId}`,
        }).then(res => {
            setTeamLeadList(res.data.data);
        }).catch(() => {})
    }

    useEffect(() => {
        getManagerList()
        getFloorManagerList('')
        getTeamLeadList('')
    }, [agentType]);

    useEffect(() => {
        getFloorManagerList()
        getTeamLeadList()
    }, [])

    const handleManagerChange = (value) => {
        setManagerID(value)
        setFloorManagerID('')
        setTeamLeadID('')
        setFloorManagerList([])
        setTeamLeadList([])
        if (value) getFloorManagerList(value)
        handleViewManagerWise(value, '', '')
    }

    const handleFloorManagerChange = (value) => {
        setFloorManagerID(value)
        setTeamLeadID('')
        setTeamLeadList([])
        if (value) getTeamLeadList(value)
        handleViewManagerWise(managerID, value, '')
    }

    const handleTeamLeadChange = (value) => {
        setTeamLeadID(value)
        handleViewManagerWise(managerID, floorManagerID, value)
    }

    const selectSx = {
        '& .MuiSelect-select': { padding: '4px 8px', fontSize: '0.75rem' },
        '& .MuiInputLabel-root': { fontSize: '0.75rem' }
    }

    return (
        <Grid container gap={0.5} alignItems="center" flexWrap="nowrap">

            {role == 14 || role == 17 ? null : (
                <Grid item style={{ minWidth: 130 }}>
                    <FormControl sx={{ width: '100%', ...selectSx }} size="small">
                        <InputLabel style={{ backgroundColor: '#fff', fontSize: '0.75rem' }}>Select Manager</InputLabel>
                        <Select
                            value={managerID}
                            label="Select Manager"
                            onChange={(e) => handleManagerChange(e.target.value)}
                            sx={{ fontSize: '0.75rem' }}
                        >
                            <MenuItem value='' sx={{ fontSize: '0.75rem' }}>All</MenuItem>
                            {managerList && managerList.length > 0 &&
                                managerList.map((data, index) => (
                                    <MenuItem key={index} value={data._id} sx={{ fontSize: '0.75rem' }}>{data.name}</MenuItem>
                                ))
                            }
                        </Select>
                    </FormControl>
                </Grid>
            )}

            <Grid item style={{ minWidth: 140 }}>
                <FormControl sx={{ width: '100%', ...selectSx }} size="small">
                    <InputLabel style={{ backgroundColor: '#fff', fontSize: '0.75rem' }}>Select Floor Manager</InputLabel>
                    <Select
                        value={floorManagerID}
                        label="Select Floor Manager"
                        onChange={(e) => handleFloorManagerChange(e.target.value)}
                        sx={{ fontSize: '0.75rem' }}
                    >
                        <MenuItem value='' sx={{ fontSize: '0.75rem' }}>All</MenuItem>
                        {floorManagerList && floorManagerList.length > 0 &&
                            floorManagerList.map((data, index) => (
                                <MenuItem key={index} value={data._id} sx={{ fontSize: '0.75rem' }}>{data.name}</MenuItem>
                            ))
                        }
                    </Select>
                </FormControl>
            </Grid>

            <Grid item style={{ minWidth: 130 }}>
                <FormControl sx={{ width: '100%', ...selectSx }} size="small">
                    <InputLabel style={{ backgroundColor: '#fff', fontSize: '0.75rem' }}>Select Team Lead</InputLabel>
                    <Select
                        value={teamLeadID}
                        label="Select Team Lead"
                        onChange={(e) => handleTeamLeadChange(e.target.value)}
                        sx={{ fontSize: '0.75rem' }}
                    >
                        <MenuItem value='' sx={{ fontSize: '0.75rem' }}>All</MenuItem>
                        {teamLeadList && teamLeadList.length > 0 &&
                            teamLeadList.map((data, index) => (
                                <MenuItem key={index} value={data._id} sx={{ fontSize: '0.75rem' }}>{data.name}</MenuItem>
                            ))
                        }
                    </Select>
                </FormControl>
            </Grid>

        </Grid>
    )
}
